import { sliderAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const $thumbSize = cssVar("slider-thumb-size");
const $trackSize = cssVar("slider-track-size");

const baseStyleFilledTrack = defineStyle((props) => {
  return { bg: "brand.clear_creek_bg" };
});

const baseStyle = definePartsStyle((props) => ({
  container: {},
  track: {},
  thumb: {},
  filledTrack: baseStyleFilledTrack(props),
}));

const sizeLg = definePartsStyle({
  container: {
    [$thumbSize.variable]: `sizes.4`,
    [$trackSize.variable]: `sizes.2`,
  },
});

const sizeMd = definePartsStyle({
  container: {
    [$thumbSize.variable]: `sizes.3`,
    [$trackSize.variable]: `sizes.1`,
  },
});

const sizeSm = definePartsStyle({
  container: {
    [$thumbSize.variable]: `sizes.2`,
    [$trackSize.variable]: `sizes.1`,
  },
});

const sizes = {
  lg: sizeLg,
  md: sizeMd,
  sm: sizeSm,
};

export const sliderTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: "md",
  },
});
